import {
  useGetLegalEntityLegalEntitiesGet,
  useGetRegionsGeographiesRegionsGet,
} from "@/services/2/react-query/hooks";

import { MultiSelectDropdown } from "../multiselect-dropdown";

type MultiRegionSelectorProps = {
  regions: string[];
  onChange: (regions?: string[]) => void;
  legalEntityUuids?: string[];
};

export const MultiRegionSelector = ({
  regions,
  onChange,
  legalEntityUuids,
}: MultiRegionSelectorProps) => {
  const queryLegalEntities = legalEntityUuids?.length ? legalEntityUuids : null;

  const { data: regionList } = useGetRegionsGeographiesRegionsGet(
    { query: { legal_entity_uuids: queryLegalEntities } },
    ["regions", queryLegalEntities?.join(",") || "all"],
    {
      staleTime: 12 * 60 * 60 * 1000, // 12 hours
      placeholderData: [],
    }
  );

  const { data: legalEntities } = useGetLegalEntityLegalEntitiesGet({}, [], {
    staleTime: 12 * 60 * 60 * 1000, // 12 hours
  });

  const getLegalEntityName = (legalEntityUuid: string) => {
    const legalEntity = legalEntities?.find(le => le.uuid === legalEntityUuid);
    return legalEntity ? legalEntity.name : undefined;
  };

  const sortedRegions = regionList?.sort((a, b) => a.name.localeCompare(b.name)) || [];

  return (
    <MultiSelectDropdown
      name="regions"
      label="Région"
      pluralLabel="Régions"
      options={sortedRegions.map(region => ({
        value: region.uuid,
        label: region.name,
        description: getLegalEntityName(region.legal_entity_uuid),
      }))}
      values={regions}
      onChangeValues={onChange}
    />
  );
};
